export function usePostRobot() {
  if (window.postRobot) return window.postRobot

  return import('post-robot').then((m) => m.default || m)
}
